import { useRef, useState, useMemo, useCallback } from 'react';
import { Image } from 'antd';
import ItemTabs from './ItemTabs';
import DataTable from '../../components/DataTable';
import DropPlayerOut from './DropPlayerOut';

import request from '@/request';

export default function Players({ event, items }) {
  const dataTableRef = useRef(null);
  const voucherLoadingRef = useRef(false);

  const [previewUrl, setPreviewUrl] = useState('');
  const [voucherLoadingId, setVoucherLoadingId] = useState(null);
  const [activeItem, setActiveItem] = useState(items[0] || null);

  const [dropOutModalVisible, setDropOutModalVisible] = useState(false);
  const [player, setPlayer] = useState({});

  const options = [
    { value: 'groupName', label: '机构名称' },
    { value: 'name', label: '选手名称' },
    { value: 'playerId', label: '选手编号' },
  ];

  // 获取选手凭证，并在请求期间拦截重复点击。
  const getVoucher = useCallback(
    async (userId) => {
      if (voucherLoadingRef.current) {
        return;
      }
      voucherLoadingRef.current = true;
      setVoucherLoadingId(userId);
      try {
        const result = await request.post('/events/item/badge', {
          userId: userId,
          eventId: event.id,
        });
        setPreviewUrl(result);
      } finally {
        voucherLoadingRef.current = false;
        setVoucherLoadingId(null);
      }
    },
    [event.id]
  );

  const playerDropOut = useCallback(
    async (reason) => {
      setDropOutModalVisible(false);
      await request.post('/events/admin/dropOut', {
        userId: player.playerId,
        eventId: event.id,
        itemIds: [activeItem.id],
        reason: reason,
      });
      if (dataTableRef.current?.refresh) {
        dataTableRef.current.refresh();
      }
    },
    [activeItem, event, player]
  );

  const columns = useMemo(() => {
    const hasMembers = activeItem && activeItem.minPlayer !== null;
    const cols = [
      {
        title: hasMembers ? '队伍' : '名字',
        dataIndex: 'name',
        key: 'name',
        render: (t, record) => {
          return (
            <span className="text-sm text-slate-900">
              {!hasMembers
                ? t
                : t +
                  ',' +
                  (record.members || []).map((t) => t.realName).join(',')}
            </span>
          );
        },
      },
      {
        title: '选手编号',
        dataIndex: 'playerId',
        key: 'playerId',
        render: (t, record) => {
          return (
            <span className="text-sm text-slate-600">
              {!hasMembers
                ? t
                : t + ',' + (record.members || []).map((t) => t.id).join(',')}
            </span>
          );
        },
      },
      {
        title: '联系电话',
        dataIndex: 'phone',
        key: 'phone',
      },
      {
        title: '选手凭证',
        key: 'voucher',
        render: (_, record) => {
          const loading = voucherLoadingId === record.playerId;
          return (
            <button
              className="font-xs text-blue-600 hover:text-blue-700 cursor-pointer disabled:cursor-not-allowed disabled:text-slate-400"
              disabled={voucherLoadingId !== null}
              onClick={() => getVoucher(record.playerId)}
            >
              {loading ? '加载中...' : '查看'}
            </button>
          );
        },
      },
    ];

    // if (activeItem && activeItem.minApply !== null) {
    //   cols.push({
    //     title: '队友',
    //     dataIndex: 'members',
    //     key: 'members',
    //     render: (t) => (
    //       <span className="text-sm text-slate-600">
    //         {(t || []).map((t) => t.realName).join(', ')}
    //       </span>
    //     ),
    //   });
    // }

    cols.push({
      title: '所属机构',
      dataIndex: 'teamName',
      key: 'teamName',
      render: (t) => <span className="text-sm text-slate-600">{t}</span>,
    });

    cols.push({
      title: '操作',
      key: 'action',
      align: 'right',
      render: (_, record) => (
        <button
          className="font-xs text-blue-600 hover:text-blue-700 cursor-pointer"
          onClick={() => {
            setPlayer(record);
            setDropOutModalVisible(true);
          }}
        >
          退赛
        </button>
      ),
    });

    return cols;
  }, [activeItem, getVoucher, voucherLoadingId]);

  return (
    <div className="space-y-6">
      <ItemTabs
        items={items}
        activeType={activeItem}
        onChange={setActiveItem}
        showApply
      />
      {activeItem?.id && (
        <DataTable
          ref={dataTableRef}
          options={options}
          onImport={() => {
            if (dataTableRef.current?.refresh) {
              dataTableRef.current.refresh();
            }
          }}
          rowKey="playerId"
          exportAPI={`/events/admin/schedule/outer/player/${activeItem?.id}`}
          columns={columns}
          api={`/events/admin/import/outer/player/list?eventId=${event?.id}&itemId=${activeItem?.id}`}
          importAPI={`/events/admin/import/outer/player?eventId=${event?.id}`}
          demoDownloadUrl="https://statics.dronex.cc/template/EDE%E6%8A%A5%E5%90%8D%E6%A8%A1%E7%89%88.xlsx"
        />
      )}
      <Image
        style={{ display: 'none' }}
        src={previewUrl}
        preview={{
          open: !!previewUrl,
          src: previewUrl,
          onOpenChange: () => setPreviewUrl(''),
        }}
      />
      <DropPlayerOut
        key={dropOutModalVisible ? 'show' : 'hide'}
        open={dropOutModalVisible}
        onCancel={() => setDropOutModalVisible(false)}
        onConfirm={playerDropOut}
        player={player}
      />
    </div>
  );
}
